<template>
  <div>
    <div class="inline-flex pb-6">
      <h1 class="inline-flex pr-4">
        DTO Move Component
        <p class="pl-4">|</p>
      </h1>
      <p class="pr-4"></p>
      <vs-button color="#5b3cc4" type="filled" icon="search" @click="grid"
        >List</vs-button
      >
      <p class="pr-4"></p>
      <vs-button color="success" type="filled" icon="add" @click="cusAdd"
        >Add</vs-button
      >
      <p class="pr-4"></p>
      <vs-button
        color="warning"
        type="filled"
        icon="create"
        @click="cusEdit"
        v-if="btndis"
        >Edit</vs-button
      >
      <p class="pr-4"></p>
      <vs-button
        color="danger"
        type="filled"
        icon="remove_circle_outline"
        @click="cusDel"
        v-if="btndis"
        >Delete</vs-button
      >
      <p class="pr-4"></p>
      <vs-button
        color="#5b3cc4"
        type="filled"
        icon="list"
        @click="goPrint"
        v-if="btndis"
        >Print</vs-button
      >
      <p class="pr-4"></p>
      <vs-button
        color="success"
        type="filled"
        icon="list"
        @click="goDetail"
        v-if="btndis"
        >Detail</vs-button
      >
      <p class="pr-4"></p>
    </div>

    <transition-group
      enter-active-class="animated lightSpeedIn"
      leave-active-class="animated lightSpeedOut"
    >
      <putadd
        v-if="addshow"
        :key="addshow"
        :acstate="acstate"
        :recid="recid"
        @grid="grid"
        :companyGroupsCode="companyGroupsCode"
        :businessPartnersCode="businessPartnersCode"
      ></putadd>
      <aggrid
        v-if="gridshow"
        :key="gridshow"
        :masrec="masrec"
        @recsel="recsel"
        :companyGroupsCode="companyGroupsCode"
        :businessPartnersCode="businessPartnersCode"
      ></aggrid>
    </transition-group>
  </div>
</template>

<script>
// import aggrid from "./DataTable/AgGrid";
import aggrid from "./grid";
import putadd from "./putadd";

import pdfMake from "pdfmake";
import pdfFonts from "../../../assets/custom-fonts";
import axios from "axios";
import { BASE_API_URL } from "@/constants/index.ts";

export default {
  data() {
    return {
      businessPartnersCode: "",
      userid: "",
      companyGroupsCode: "",
      addshow: false,
      gridshow: false,
      btndis: false,
      recid: "0",
      curX: null,
      curY: null,
      acstate: null,
      masrec: null,
      fabact: [
        { act: "cusAdd", label: "Add" },
        { act: "cusEdit", label: "Edit" },
        { act: "cusDel", label: "Delete" },
        { act: "goPrint", label: "PrintQR" },
        { act: "goDetail", label: "Inbdetails" },
        { act: "hideFab", label: "Hide" },
      ],
    };
  },
  computed: {
    fabStyle: function () {
      return {
        left: this.curX + "px",
        top: this.curY + "px",
      };
    },
  },
  methods: {
    handle_function_call(function_name) {
      this[function_name]();
    },
    recsel(val) {
      this.btndis = true;
      this.recid = val;
    },
    cusAdd() {
      this.recid = 0;
      this.addshow = true;
      this.gridshow = false;
      this.btndis = false;
      this.acstate = "ADD";
    },
    grid() {
      this.addshow = false;
      this.gridshow = true;
      this.btndis = false;
      this.$store.dispatch("setReportGrid", 0);
    },
    goDetail() {
      this.btndis = true;
      this.$router.replace("/dtomovesdetails/" + this.recid);
    },
    goDate() {
      let today = new Date();
      let dd = today.getDate();

      let mm = today.getMonth() + 1;
      let yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }

      if (mm < 10) {
        mm = "0" + mm;
      }
      this.daday = dd;
      this.damonth = mm;
      this.dayear = Number(yyyy) + 543;
      this.dtoday = dd + "-" + mm + "-" + yyyy;
    },
    getArray(data) {
      // console.log(data);
      this.arData = [];

      let i = 1;

      data.forEach((item) => {
        // item.updated_at = item.updated_at
        //   ? item.updated_at.replace(/-/g, "/")
        //   : null;
        this.arData.push([
          {
            text: i,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.inbordersnumber,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.inbitemnum,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.inbdetailsSkuscode,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.edescription,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: this.formatnumber(item.itempck),
            fontSize: 10,
            bold: false,
            alignment: "right",
          },
          {
            text: item.fcompanyGroupsCode,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
          {
            text: item.tcompanyGroupsCode,
            fontSize: 10,
            bold: false,
            alignment: "center",
          },
        ]);

        i++;
        // console.log(i);
      });
    },
    cvDate(date) {
      let d = new Date(date);
      let dformat =
        [d.getDate(), d.getMonth() + 1, d.getFullYear()].join("/") +
        " " +
        [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
      return dformat;
    },
    getArraySep(data) {
      // console.log(data);
      this.arData = [];

      let i = 1;

      data.forEach((item) => {
        // item.updated_at = item.updated_at
        //   ? item.updated_at.replace(/-/g, "/")
        //   : null;
        this.arData.push([
          {
            text: i,
            fontSize: 10,
            bold: true,
            alignment: "center",
          },
          {
            text: item.cmansNumber,
            fontSize: 10,
            bold: true,
            alignment: "center",
          },
          {
            text: item.description,
            fontSize: 10,
            bold: true,
            alignment: "left",
          },
          {
            text:
              this.formatnumber(item.totalpckamount) + " " + item.totalpckunit,
            fontSize: 10,
            bold: true,
            alignment: "right",
          },
          {
            text: this.formatnumber(item.totalgw) + " " + item.totalgwunit,
            fontSize: 10,
            bold: true,
            alignment: "right",
          },
        ]);

        i++;
        // console.log(item.totalgw);
      });
    },
     formatnumber(number) {
      return number.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    getBase64ImageFromURL(url) {
      return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = () => {
          var canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;

          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          // var dataURL = canvas.toDataURL("image/png");
          var dataURL = canvas.toDataURL("image/png");

          resolve(dataURL);
        };

        img.onerror = (error) => {
          reject(error);
        };

        img.src = url;
      });
    },
    async goPrint() {
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        this.loading = true;

        if (token) {
          const formData = {
            companyGroupsCode: this.companyGroupsCode,
            number: this.recid,
            // from: '2022-01-11'
          };
          // const response = await axios.post(`${BASE_API_URL}/agents/findall`, formData);

          const response = await axios.post(
            `${BASE_API_URL}/inbound-svc/moves/printMoves`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          // console.log(response.data.status);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error",
              text: response.data.message,
            });
          } else {
            // console.log(response.data);

            this.getArray(response.data.movesDetails);

            const docDefinition = {
              // a string or { width: number, height: number }
              pageSize: "A4",

              // by default we use portrait, you can change it to landscape if you wish
              pageOrientation: "landscape",

              footer: {
                // columns: [
                //   "Left part",
                //   { text: "Right part", alignment: "right" },
                // ],
                columns: [
                  [
                    {
                      text: "พิมพ์ ณ วันที่ " + this.cvDate(new Date()),
                      fontSize: 14,
                      alignment: "right",
                      // [left, top, right, bottom]
                      // margin: [100, -20, 0, 0],
                      margin: [0, 0, 10, 0],
                    },
                  ],
                ],
              },

              content: [
                {
                  text: "ใบสั่งการย้ายสินค้าระหว่างผู้ประกอบการ",
                  style: "title",
                  // [left, top, right, bottom]
                  margin: [0, -20, 0, 0],
                },
                {
                  text: "ใบย้ายสินค้าเลขที่ " + response.data.movesNumber,
                  style: "subtitle",
                  margin: [0, 0, 0, 10],
                },
                {
                  table: {
                    // headers are automatically repeated if the table spans over multiple pages
                    // you can declare how many rows should be treated as headers
                    headerRows: 1,
                    widths: [25, 70, 45, 140, 185, 45, 100, 100], // 525(portrait) 700(landscape)
                    body: [
                      [
                        {
                          text: "ลำดับ",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Inbound Number",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Inbound Item",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Product Code",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Description",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "Package",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "From DTO",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                        {
                          text: "To DTO",
                          bold: true,
                          fontSize: 10,
                          alignment: "center",
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    heights: 15,
                    widths: [25, 70, 45, 140, 185, 45, 100, 100], // 525(portrait) 700(landscape)
                    // body: this.getArray(res.data.message),
                    body: this.arData,
                    // body: [[{}, {}, {}, {}, {},{}, {}, {}]],
                  },
                },
              ],
              defaultStyle: {
                // 4. default style 'THSarabunNew' font to test
                font: "THSarabunNew",
              },
              styles: {
                title: {
                  fontSize: 18,
                  bold: true,
                  alignment: "center",
                },
                subtitle: {
                  fontSize: 16,
                  bold: true,
                  alignment: "center",
                },
                header: {
                  fontSize: 18,
                  bold: true,
                  alignment: "right",
                  margin: [0, 190, 0, 80],
                },
                subheader: {
                  fontSize: 14,
                },
                superMargin: {
                  margin: [20, 0, 40, 0],
                  fontSize: 15,
                },
              },
            };

            pdfMake.vfs = pdfFonts.pdfMake.vfs; // 2. set vfs pdf font
            pdfMake.fonts = {
              // default Roboto font
              Roboto: {
                normal: "Roboto-Regular.ttf",
                bold: "Roboto-Medium.ttf",
                italics: "Roboto-Italic.ttf",
                bolditalics: "Roboto-MediumItalic.ttf",
              },
              // THSarabunNew Font
              THSarabunNew: {
                normal: "THSarabunNew.ttf",
                bold: "THSarabunNew Bold.ttf",
                italics: "THSarabunNew italic.ttf",
                bolditalics: "THSarabunNew Bolditalic.ttf",
              },
            };

            setTimeout(() => {
              pdfMake.createPdf(docDefinition).open();
            }, 1000);

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Print Complete",
              text: "Print Complete",
            });
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // await this.$router.replace("/pages/login/");
      }
    },
    cusEdit() {
      this.addshow = true;
      this.gridshow = false;
      this.btndis = false;
      this.acstate = "EDIT";
    },
    cusDel() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Do you want to Delete? " + this.recid,
        accept: this.acceptAlert,
      });
    },
    async acceptAlert() {
      this.btndis = false;

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        if (token) {
          const formData = {
            number: this.recid,
            editor: String(this.userid),
            companyGroupsCode: this.companyGroupsCode,
          };

          const response = await axios.post(
            `${BASE_API_URL}/inbound-svc/moves/delete`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
            });
          } else {
            if (this.$store.state.reportgrid == 0) {
              this.$store.dispatch("setReportGrid", 1);
            } else {
              this.$store.dispatch("setReportGrid", 0);
            }

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Deleted Complete",
              text: response.data.message,
            });
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }

      // this.gridshow = false;
      // this.gridshow = true;
    },
    getXY(event) {
      this.curX = event.clientX;
      this.curY = event.clientY;

      // console.log(this.curX);
      // console.log(this.curY);
    },
    hideFab() {
      this.btndis = false;
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        // console.log(decoded);

        try {
          // console.log(response.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;

          // this.businessPartnersCode = decoded.businessPartnersCode;
          this.companyGroupsCode = decoded.companyGroupsCode;
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/");
        }
      } else {
        alert("กรุณาเข้าระบบอีกครั้ง");
        await this.$router.replace("/");
      }
    },
  },
  mounted() {
    this.checkProfiles();
    // console.log(this.$acl.check('admin'));
  },
  components: {
    aggrid,
    putadd,
  },
};
</script>

<style scoped>
.fab-wrapper {
  position: fixed;
  left: 100px;
  top: 500px;
  z-index: 5;
  display: flex;
  flex-direction: center;
  align-items: center;
}
.fab {
  background-color: rgb(231, 55, 55);
}
</style>
